import { SVGProps, memo } from 'react';
import { useTheme } from '@mui/material/styles';

const DeleteIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={props.width || "24"} height={props.height || "26"} viewBox="0 0 24 26" fill={props.fill ||  "none"} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.12305 5.87565H3.45638M3.45638 5.87565H22.123M3.45638 5.87565V22.209C3.45638 22.8278 3.70221 23.4213 4.1398 23.8589C4.57738 24.2965 5.17087 24.5423 5.78971 24.5423H17.4564C18.0752 24.5423 18.6687 24.2965 19.1063 23.8589C19.5439 23.4213 19.7897 22.8278 19.7897 22.209V5.87565M6.95638 5.87565V3.54232C6.95638 2.92348 7.20221 2.32999 7.6398 1.8924C8.07738 1.45482 8.67087 1.20898 9.28971 1.20898H13.9564C14.5752 1.20898 15.1687 1.45482 15.6063 1.8924C16.0439 2.32999 16.2897 2.92348 16.2897 3.54232V5.87565M9.28971 11.709V18.709M13.9564 11.709V18.709" stroke={props.stroke || "#0000008F"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
};

export default memo(DeleteIcon);
